export default function PricingPlans() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const plans = [
    {
      name: 'ライトプラン',
      price: '5,000',
      features: [
        'ウェブサイトの作成、管理',
        'お問い合わせフォーム管理',
        '月4回の修正依頼',
        '月1回の簡易アクセスレポート'
      ],
      popular: false
    },
    {
      name: 'スタンダードプラン',
      price: '10,000',
      features: [
        'ライトプランのすべて',
        'カスタムドメイン',
        '月8回の修正依頼',
        '月2回のアクセスレポート',
        '簡易SEO'
      ],
      popular: true
    },
    {
      name: 'プレミアムプラン',
      price: '15,000',
      features: [
        'スタンダードプランのすべて',
        '月15回の修正依頼',
        '構成・文章をヒアリングベースで設計',
        '月1回の改善提案付きアクセスレポート',
        '優先対応(48時間以内)'
      ],
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            料金プラン
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            あなたのビジネスに最適なプランをお選びください
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 sm:p-8 ${
                plan.popular ? 'ring-2 ring-teal-500 transform scale-100 lg:scale-105' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 sm:px-6 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-lg whitespace-nowrap">
                    人気プラン
                  </span>
                </div>
              )}

              <div className="text-center mb-6 sm:mb-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                  {plan.name}
                </h3>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl sm:text-5xl font-bold text-teal-600">
                    ¥{plan.price}
                  </span>
                  <span className="text-base sm:text-lg text-gray-600 ml-2">/月</span>
                </div>
              </div>

              <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-teal-500 text-lg sm:text-xl mr-3 flex-shrink-0 mt-0.5"></i>
                    <span className="text-sm sm:text-base text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                onClick={scrollToContact}
                className={`w-full py-3 sm:py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                  plan.popular
                    ? 'bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:from-teal-600 hover:to-teal-700 shadow-lg hover:shadow-xl'
                    : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                }`}
              >
                このプランを選ぶ
              </button>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 mb-6 sm:mb-8">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">オプション</h3>
          <div className="space-y-3 sm:space-y-4">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 bg-gray-50 rounded-lg">
              <div className="mb-2 sm:mb-0">
                <h4 className="font-semibold text-gray-900 text-sm sm:text-base">無制限の修正依頼</h4>
                <p className="text-xs sm:text-sm text-gray-600 mt-1">内容は軽微修正のみ。大幅改修は別途お見積り</p>
              </div>
              <span className="text-lg sm:text-xl font-bold text-teal-600 whitespace-nowrap">¥5,000/月</span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between p-4 bg-gray-50 rounded-lg">
              <div className="mb-2 sm:mb-0">
                <h4 className="font-semibold text-gray-900 text-sm sm:text-base">緊急対応</h4>
                <p className="text-xs sm:text-sm text-gray-600 mt-1">24時間以内の対応が必要な場合</p>
              </div>
              <span className="text-lg sm:text-xl font-bold text-teal-600 whitespace-nowrap">¥3,000/回</span>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-teal-50 to-teal-100 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8">
          <p className="text-xs sm:text-sm text-gray-700 mb-2">
            ※ 大幅なデザイン変更・構成変更は別途お見積りとなります。
          </p>
          <p className="text-xs sm:text-sm text-gray-600">
            2025/12/15改正
          </p>
        </div>

        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm sm:text-base rounded-lg font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-smile-3-line mr-2"></i>
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}